module.exports = __webpack_public_path__ + "img/30.0ab264f9.gif";